import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Auth/Login.vue'
import Signup from '../views/Auth/Signup.vue'
import Createplaylist from '../views/Playlists/Createplaylist.vue'
import Playlistdetail from '../views/Playlists/Playlistdetail.vue'
import Userplaylist from '../views/Playlists/Userplaylist.vue'
import { projectAuth } from '../firebase/config'

const requireAuth = (to, from, next) => {
  const user = projectAuth.currentUser;
  if(!user){
    next({ name: 'Login'});
  } else {
    next();
  }
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: requireAuth
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  },
  {
    path: '/createplaylist',
    name: 'Createplaylist',
    component: Createplaylist,
    beforeEnter: requireAuth
  },
  {
    path: '/playlistdetail/:id',
    name: 'Playlistdetail',
    component: Playlistdetail,
    beforeEnter: requireAuth,
    props: true
  },
  {
    path: '/playlist/user',
    name: 'Userplaylist',
    component:  Userplaylist,
    beforeEnter: requireAuth
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
